<p>
<button matButton (click)="createPackage()"><mat-icon>add</mat-icon>Créer un nouveau forfait</button>
</p>

<br>

<ag-grid-angular
    style="width: 100%; height: 100%;"
    [columnDefs]="columns"
    [autoSizeStrategy]="autoSizeStrategy"
    [loading]="true"
    [localeText]="localeText"
    [getRowId]="getRowId"
    (rowDoubleClicked)="selectPackage($event.data?.uuid)"
    (gridReady)="onGridReady($event)"
/>